import { render, staticRenderFns } from "./MessageEditor.html?vue&type=template&id=1bd3d430&scoped=true&external"
import script from "./MessageEditor.js?vue&type=script&lang=js&external"
export * from "./MessageEditor.js?vue&type=script&lang=js&external"
import style0 from "./MessageEditor.scss?vue&type=style&index=0&id=1bd3d430&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3d430",
  null
  
)

export default component.exports